export const RECENT_ENTITIES_QUANTITY = 5;
